export default __webpack_public_path__ + "static/media/full_screen_icon.1b42d0f3.svg";